<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Proxmox Login</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Home </a></li>
                        <li>Pages</li>
                        <li>User</li>
                        <li>Proxmox Login</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="user-area-all-style log-in-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="contact-form-action">
                    <div class="form-heading text-center mb-4">
                        <h3 class="form-title">Login to Proxmox</h3>
                        <p class="form-desc">Access your Proxmox Virtual Environment</p>
                    </div>

                    <div class="alert alert-info" *ngIf="connectionTestResult">
                        <strong>Connection Test:</strong> {{ connectionTestResult }}
                    </div>

                    <div class="alert alert-danger" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>

                    <div class="mb-3">
                        <button class="btn btn-secondary" (click)="testConnection()">Test Connection</button>
                    </div>

                    <form (ngSubmit)="onLogin()" #loginForm="ngForm">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 mb-3">
                                <div class="form-check">
                                    <input 
                                        type="checkbox" 
                                        class="form-check-input" 
                                        id="useApiToken" 
                                        [(ngModel)]="useApiToken" 
                                        name="useApiToken">
                                    <label class="form-check-label" for="useApiToken">
                                        Use API Token Authentication
                                    </label>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12" *ngIf="!useApiToken">
                                <div class="form-group">
                                    <label for="username">Username</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        id="username" 
                                        name="username" 
                                        [(ngModel)]="username" 
                                        placeholder="Enter your Proxmox username"
                                        required>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12" *ngIf="!useApiToken">
                                <div class="form-group">
                                    <label for="password">Password/Token</label>
                                    <input 
                                        type="password" 
                                        class="form-control" 
                                        id="password" 
                                        name="password" 
                                        [(ngModel)]="password" 
                                        placeholder="Enter your password or token"
                                        required>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12" *ngIf="useApiToken">
                                <div class="form-group">
                                    <label for="apiToken">API Token</label>
                                    <textarea 
                                        class="form-control" 
                                        id="apiToken" 
                                        name="apiToken" 
                                        [(ngModel)]="apiToken" 
                                        rows="3"
                                        placeholder="Enter your API token (e.g., PVEAPIToken=root@pam!cloud=fc2bc35d-1107-4887-be1b-8617c970c518)"
                                        required></textarea>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="rememberMe" name="rememberMe">
                                        <label class="form-check-label" for="rememberMe">Remember Me</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <button 
                                    class="default-btn btn-two w-100" 
                                    type="submit" 
                                    [disabled]="isLoading || (!useApiToken && !loginForm.form.valid)">
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    <span *ngIf="isLoading">Logging in...</span>
                                    <span *ngIf="!isLoading">Login to Proxmox</span>
                                </button>
                            </div>

                            <div class="col-lg-12 col-md-12 mt-3" *ngIf="!useApiToken">
                                <div class="text-center">
                                    <p class="account-desc">
                                        <i class="bx bx-info-circle"></i> 
                                        Pre-filled with default credentials for demonstration
                                    </p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>